import {
  getApplicationPhaseLabel,
  getApplicationTypeLabel,
  RL_APPLICATION_TYPE,
} from "../../../config/phaseConstants";

interface NavbarApplicationInfoProps {
  applicationId?: string | number | null;
  status?: string | null;
  applicationType?: unknown; // raw rl_application_type
  currentPhase?: unknown; // raw current_phase
}

export function NavbarApplicationInfo({
  applicationId,
  status,
  applicationType,
  currentPhase,
}: NavbarApplicationInfoProps) {
  const typeLabel = getApplicationTypeLabel(applicationType);
  const phaseLabel = getApplicationPhaseLabel(currentPhase);
  const showPhase = applicationType !== RL_APPLICATION_TYPE.PERMANENT;

  return (
    <div className="flex flex-col md:flex-row md:ml-auto md:mr-8 gap-y-1 md:gap-x-8">
      <div>
        <p className="text-grey-600">
          <span className="w-28 font-semibold inline-block">
            Application ID
          </span>
          <span className="text-grey-600 font-semibold mx-2">:</span>
          <span>{applicationId || "Nil"}</span>
        </p>
        <p className="text-grey-600 flex items-center">
          <span className="w-28 text-grey-600 font-semibold inline-block">
            Status
          </span>
          <span className="text-grey-600 font-semibold mx-2">:</span>
          <span className="text-primary">{status || "Nil"}</span>
        </p>
      </div>
      <div>
        <p className="text-grey-600">
          <span className="w-36 font-semibold inline-block">
            Application Type
          </span>
          <span className="text-grey-600 font-semibold mx-2">:</span>
          <span>{typeLabel}</span>
        </p>
        {showPhase && (
          <p className="text-grey-600 flex items-center">
            <span className="w-36 text-grey-600 font-semibold inline-block">
              Application Phase
            </span>
            <span className="text-grey-600 font-semibold mx-2">:</span>
            <span>{phaseLabel}</span>
          </p>
        )}
      </div>
    </div>
  );
}
